export default __webpack_public_path__ + "static/media/029-eagle.d552072f.svg";